export * from './baFullCalendar.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baFullCalendar/index.ts